export default {
  setCrashes (state, payload) {
    state.list = payload
  }
}